
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import Vue from 'vue'
require('./bootstrap');
window.Vue = require('vue');
import BootstrapVue from 'bootstrap-vue';
import swal from 'sweetalert';
import Swal from 'sweetalert2';
window.Swal = Swal;
Vue.use(BootstrapVue);
import { BSpinner } from 'bootstrap-vue'
Vue.component('b-spinner', BSpinner)

import 'bootstrap-vue/dist/bootstrap-vue.css'


/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
Vue.component('user-notifications', require('./components/Notifications.vue').default);
Vue.component('logo-upload', require('./components/LogoUpload.vue').default);
Vue.component('inbox-pcrs', require('./components/InboxPcrs.vue').default);
Vue.component('archived-students', require('./components/ArchivedStudents.vue').default);
Vue.component('new-account', require('./components/NewAccountButton.vue').default);
Vue.component('problem-summary', require('./components/ProblemSummary.vue').default);
Vue.component('emoji-preference', require('./components/EmojiPreference.vue').default);
Vue.component('saved-formatives', require('./components/SavedFormatives.vue').default);
Vue.component('evaluation-summary', require('./components/EvaluationSummary.vue').default);
Vue.component('pending-formatives', require('./components/PendingFormatives.vue').default);
Vue.component('student-files', require('./components/StudentFile.vue').default);
Vue.component('assessed-competencies-preceptors', require('./components/AssessedCompetenciesPreceptors.vue').default);
Vue.component('user-locations', require('./components/UserLocations.vue').default);
Vue.component('attempt-log', require('./components/AttemptLog.vue').default);
Vue.component('evaluation-files', require('./components/EvaluationFiles.vue').default);
Vue.component('competency-files', require('./components/CompetencyFiles.vue').default);
Vue.component('saved-competencies', require('./components/SavedCompetencies.vue').default);
Vue.component('schedule-others', require('./components/ScheduleOthers.vue').default);
Vue.component('schedule', require('./components/Schedule.vue').default);
Vue.component('users-list', require('./components/Users.vue').default);
Vue.component('preceptors', require('./components/Preceptors.vue').default);
Vue.component('formative-evaluations', require('./components/FormativeEvaluations.vue').default);
Vue.component('inbox-evaluations', require('./components/InboxEvaluations.vue').default);
Vue.component('completed-evaluations', require('./components/CompletedEvaluations.vue').default);
Vue.component('sent-evaluations', require('./components/SentEvaluations.vue').default);
Vue.component('pending-evaluations', require('./components/PendingEvaluations.vue').default);
Vue.component('evaluations', require('./components/Evaluations.vue').default);
Vue.component('attempts', require('./components/Attempts.vue').default);
Vue.component('inbox-competencies', require('./components/InboxCompetencies.vue').default);
Vue.component('pending-competencies', require('./components/PendingCompetencies.vue').default);
Vue.component('sent-competencies', require('./components/SentCompetencies.vue').default);
Vue.component('assessed-competencies', require('./components/AssessedCompetencies.vue').default);
Vue.component('completed-competencies', require('./components/CompletedCompetencies.vue').default);
Vue.component('competencies', require('./components/Competencies.vue').default);
Vue.component('neo-competencies', require('./components/NeoCompetencies.vue').default);
Vue.component('ped-competencies', require('./components/PedCompetencies.vue').default);
Vue.component('competency-list', require('./components/CompetencyList.vue').default);
Vue.component('additional-forms', require('./components/AdditionalFormList.vue').default);
Vue.component('additional-form-evaluations', require('./components/InboxAdditionalForms.vue').default);
Vue.component('pcr-form', require('./components/PCRForm.vue').default);


const app = new Vue({
    el: '#app'
});
